import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL, ENDPOINTS } from "../api";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Grid,
} from "@mui/material";
import logo from "../assets/images/logo.png";
import Center from "./Center";
const ExamControl = () => {
  const [results, setResults] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [questions, setQuestions] = useState([]);
  const adminToken = localStorage.getItem("adminToken");

  const startExam = async () => {
    try {
      await axios.post(`${BASE_URL}api/${ENDPOINTS.startExam}`);
    } catch (error) {
      console.error("Error starting exam:", error);
    }
  };

  const endExam = async () => {
    try {
      await axios.post(`${BASE_URL}api/${ENDPOINTS.endExam}`);
    } catch (error) {
      console.error("Error ending exam:", error);
    }
  };
  const getTotalUsers = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}api/${ENDPOINTS.countParticipants}`
      );
      setTotalUsers(response.data);
    } catch (error) {
      console.error("Error fetching total users:", error.response);
    }
  };

  useEffect(() => {
    getTotalUsers(); // Fetch total users when the component mounts
  }, []);

  const showResults = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}api/${ENDPOINTS.getResults}`
      );
      const questionsResponse = await axios.get(
        `${BASE_URL}api/${ENDPOINTS.question}`
      );
      setResults(response.data);
      setQuestions(questionsResponse.data);
    } catch (error) {
      console.error("Error fetching results:", error);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <Center>
      <div className="admin-panel-container">
        <div className="img-section">
          <img
            src={logo}
            alt="logo"
            style={{ width: "200px", textAlign: "center" }}
          />
        </div>
        <h1>Admin Panel</h1>
        <button onClick={startExam}>Start Exam</button>
        <button onClick={endExam}>End Exam</button>
        <button onClick={showResults}>Show Results</button>
        <p>No. of Users : {totalUsers}</p>

        {results.length > 0 && (
          <div>
            <h2 className="text-center">User's Result</h2>

            <TableContainer component={Paper} style={{ overflowX: "auto" }}>
              <Table>
                <TableHead>
                  <TableRow
                    style={{
                      background: "#2c2e2c",
                      color: "white",
                    }}
                  >
                    <TableCell style={{ fontWeight: "bold" }}>NAME</TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>EMAIL</TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>SCORE</TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      TIME TAKEN
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                    ? results.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                    : results
                  ).map((result) => (
                    <TableRow
                      style={{ background: "white" }}
                      key={result.participantId}
                    >
                      <TableCell
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        {result.name}
                      </TableCell>
                      <TableCell
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        {result.email}
                      </TableCell>
                      <TableCell
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        {result.score}/{questions.length}
                      </TableCell>
                      <TableCell
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        {result.timeTaken}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <TablePagination
                style={{ backgroundColor: "white", color: "red" }}
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={results.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                nextIconButtonProps={{
                  style: { backgroundColor: "#fc4906", color: "white" },
                }}
                backIconButtonProps={{
                  style: { backgroundColor: "#fc4906", color: "white" },
                }}
                labelRowsPerPage={
                  <span style={{ color: "black" }}>
                    <b>Rows per page :</b>
                  </span>
                }
              />
            </div>
          </div>
        )}
      </div>
    </Center>
  );
};

export default ExamControl;
